<div class="succuss-model">
  <button id="close" mat-flat-button disableRipple>
    <i class="material-icons" [mat-dialog-close]="true">close</i>
  </button>
  <div mat-dialog-content class="content">
    <img src="assets/icons/checkmark.svg" alt="checkMark icon" />
    <h4>CONGRATULATIONS!</h4>
    <p class="dialog-note">{{ data?.message }}</p>
  </div>
  <div class="model-btns">
    <button (click)="noClick()" mat-button class="btn cancel">
      {{ data.cancel ? data.cancel : "cancel" }}
    </button>
    <button id="save" mat-flat-button [mat-dialog-close]="true">Ok</button>
  </div>
</div>
